import React from "react";
import { Tooltip } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
const categoryDescriptions = {
    network: "Has network related indicators",
    evasion: "Tries to evade common debuggers/sandboxes/analysis tools",
    stealth: "Tries to hide its presence",
    autostart: "Tampers with autostart settings",
    memory: "Tampers with memory of foreign processes",
    document: "Exhibits unusual activities when handling documents",
    anomaly: "Contains unusual characteristics",
    monitor: "Able to monitor host activities",
    disable: "May disable system services",
    registry: "Accesses registry and configuration files in an unusual way",
    execution: "Creates other processes or starts other applications",
    permissions: "Tampers with or requires permissions",
    search: "Enumerates or collects information from a system",
    settings: "Tampers with system settings",
    macro: "Contains macro functions or scripts",
    flow: "Leaks sensitive information to external hosts",
    behavior: "Automatically execute activities as a user",
    signature: "Matches a known signature",
    steal: "Steals and leaks sensitive information",
    family: "Associated with known malicious families",
    packer: "Contains obfuscated or encrypted code or data",
    exploit: "Contains known exploits against the system",
    file: "Accesses files in an unusual way",
    payload: "Extracts and launches new behavior in an unusual way",
};
const BehaviorCategory = ({ category, }) => {
    return (React.createElement(Tooltip, { trigger: "term", placement: "bottom", title: categoryDescriptions[category.toLowerCase()] },
        React.createElement("span", null, capitalizeFirstLetter(category))));
};
export default BehaviorCategory;
//# sourceMappingURL=BehaviorCategory.js.map